import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";
export function addProductionOrder(
  productionOrder,
  formatRequestBody = formatProductionOrderRequestBody
) {
  return api.post(
    UtilsUrl.productionURL() + "/production-orders",
    formatRequestBody(productionOrder)
  );
}

export function getProductionOrderById({ queryKey }) {
  const [_, id] = queryKey;

  return api
    .get(
      UtilsUrl.productionURL() +
        `/production-orders/${id}?multi-level=true&flat=true`
    )
    .then((res) => res.data);
}

export function getProductionOrders() {
  return api.get(UtilsUrl.productionURL() + "/production-orders");
  // .then((res) => res.data)
  // .catch((error) => {
  //   console.log("production-orders error", error);
  // });
}

export function confirmProductionOrder(id) {
  return api
    .post(UtilsUrl.productionURL() + `/production-orders/${id}/state`, {
      state: "CONFIRMED",
    })
    .then((res) => res.data);
}

export function updateProductionOrderComponentsDetails({
  productionOrderId,
  data,
  formatData = formatComponentsDetailsRequestBody,
}) {
  if (!data || data.length === 0) return;

  return api
    .post(
      UtilsUrl.productionURL() +
        `/production-orders/${productionOrderId}/components-details`,
      formatComponentsDetailsRequestBody(data)
    )
    .then((res) => res.data);
}

export function formatProductionOrderRequestBody({
  product,
  billOfMaterials,
  quantity,
  code,
  scheduledDate,
  assignedTo,
}) {
  return {
    productId: product.id,
    billOfMaterialsId: billOfMaterials.id,
    quantity,
    code,
    scheduledDate,
    assignedTo,
  };
}

function formatComponentsDetailsRequestBody(requestBody) {
  return requestBody.map(({ id, consumedQte, reservedQte }) => ({
    productId: id,
    consumedQte,
  }));
}
